import styled from "styled-components";

const MainContent = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export default MainContent;
